export const ImagePosition = Object.freeze({
  LEFT: "left",
  RIGHT: "right",
});
